import { CommonModule } from '@angular/common';
import { Component, input, OnInit, output } from '@angular/core';
import { DropdownPosition, NgSelectModule } from '@ng-select/ng-select';
import { debounceTime, distinctUntilChanged, filter, Subject } from 'rxjs';
import { AutoSelect } from '../../models/auto-select/auto-select';

@Component({
  selector: 'smarsh-auto-select',
  standalone: true,
  imports: [NgSelectModule, CommonModule],
  templateUrl: './auto-select.component.html',
  styles: ''
})
export class AutoSelectComponent implements OnInit {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  items = input.required<any>(); //Using any as it's generic
  label = input.required<string>();
  value = input.required<string>();
  dropdownPosition = input<DropdownPosition>('auto');
  isLoading = input.required<boolean>();
  search = output<AutoSelect>();
  searchSubject: Subject<AutoSelect> = new Subject<AutoSelect>();
  triggerSearchAfterChars = input<number>(0);
  debounce = input<number>(0);
  selected = output<AutoSelect>();
  closed = output();
  cleared = output();
  placeholder = input<string>('');

  ngOnInit() {
    this.searchSubject
      .pipe(
        debounceTime(this.debounce()),
        distinctUntilChanged(),
        filter(
          (event: AutoSelect) =>
            event?.term.length >= this.triggerSearchAfterChars()
        )
      )
      .subscribe((value) => {
        this.search.emit(value);
      });
  }

  handleSearch(event: AutoSelect) {
    this.searchSubject.next(event);
  }
}
